module.exports = __webpack_public_path__ + "img/story.d1cc46cf.jpg";